import { normalizeText } from './normalizeText';
import { PAGE_TITLE_BASE } from '../constants';

/**
 * Construye el page_path concatenado tipo path, con guion bajo en lugar de espacios (snake_case).
 *
 * Ejemplos:
 *   buildPagePath(['cuartos'])
 *     → 'node/mundial2026/cuartos'
 *   buildPagePath(['fase de grupos', 'grupo a'])
 *     → 'node/mundial2026/fase_de_grupos/grupo_a'
 *
 * Cada segmento se normaliza (minusculas, sin tildes) y luego sus espacios
 * internos se reemplazan por guion bajo.
 */
export const buildPagePath = (segments = []) => {
  const validSegments = (Array.isArray(segments) ? segments : [])
    .filter(Boolean)
    .map((segment) => normalizeText(segment).replace(/\s+/g, '_'))
    .filter((s) => s.length > 0);

  return [PAGE_TITLE_BASE, ...validSegments].join('/');
};
